import {
  fetchCumulativeWinnersHistory,
  downloadCumulativeWinnersHistoryReport,
} from 'dashboard/actions/cumulative-winners/cumulative-winners.actions';
import { fetchTiersDictionary } from 'app/actions/dictionaries/tiers-dictionary.actions';
import { fetchInvoiceDatesDictionary } from 'app/actions/dictionaries/invoice-dates-dictionary.actions';
import { initGrid } from 'utils/grid/grid';
import CumulativeHistoryTemplate from './cumulative-history.html';

const mapStateToThis = ({ session, config, dictionary, cumulativeWinners, ui }) => {
  const { serverTime, retailer } = session;
  const { defaultPageNo, pageSizeKey, defaultPageSizes, sortColumnKey, directionKey } = config;
  const { tiers, invoiceDates } = dictionary;
  const { items, isLoading } = cumulativeWinners;
  const { pagination } = ui;

  return {
    serverTime,
    retailer,
    defaultPageNo,
    pageSizeKey,
    defaultPageSizes,
    sortColumnKey,
    directionKey,
    tiers,
    invoiceDates,
    items,
    isLoading,
    pagination,
  };
};

const mapDispatchToThis = {
  fetchTiersDictionary,
  fetchInvoiceDatesDictionary,
  fetchCumulativeWinnersHistory,
  downloadCumulativeWinnersHistoryReport,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', '$state', 'tableService')
class CumulativeHistoryController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    await this.fetchDictionaries();
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.tableConfig = this.tableService.initConfig({ configName: 'cumulativeHistory' });
    this.headers = this.tableConfig.getHeaders(this.getHeaders());
    this.defaultParams = {
      [this.sortColumnKey]: 'validationDate',
      [this.directionKey]: false,
      [this.pageSizeKey]: this.defaultPageSizes[2],
    };
    this.gridModel = await initGrid(this.fetchCumulativeWinnersHistory, this.defaultParams);
    this.initializeFilters();
    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async fetchDictionaries() {
    return Promise.all([this.fetchTiersDictionary(), this.fetchInvoiceDatesDictionary()]);
  }

  preserveFilters() {
    this.preservedFilters = { ...this.gridModel.pagingModel.filters };
  }

  initializeFilters() {
    this.gridModel.pagingModel.filters = {
      invoiceEndDate: this.invoiceDates[0].id,
      retailerId: this.retailerId,
    };
  }

  search() {
    this.maintenance = false;
    this.gridModel
      .applyFilters()
      .then(() => {
        this.preserveFilters();
      })
      .catch((err) => {
        console.error('CUMULATIVE_WINNERS_HISTORY', err);
        this.maintenance = true;
      });
  }

  clearFilter() {
    this.initializeFilters();
    return this.search();
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Game Name'),
        field: 'gameName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Type'),
        field: 'type',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Winning Amount'),
        field: 'winningAmount',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Validation Date'),
        field: 'validationDate',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Ticket Number'),
        field: 'ticketNumber',
        sortable: true,
      },
    ];
  }

  downloadReport(format) {
    const params = {
      ...this.gridModel.pagingModel,
      ...this.preservedFilters,
      pageSize: 0, // BE contract - pageSize = 0 triggers exporting entire data set
    };
    return this.downloadCumulativeWinnersHistoryReport(params, format);
  }
}

export default class CumulativeWinnersHistoryComponent {
  constructor() {
    this.template = CumulativeHistoryTemplate;
    this.controller = CumulativeHistoryController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/cumulative-winners/components/cumulative-history-component.js